export default "dist/immunum_bg.wasm";